import React, { useState, useEffect, useCallback } from "react";
import { usePagination } from "../hooks";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputBase,
  IconButton,
  TablePagination,
  Collapse,
  Button,
  Skeleton,
  Divider,
} from "@mui/material";
import {
  Search as SearchIcon,
  RestartAlt as RestartAltIcon,
} from "@mui/icons-material";
import { getListFullFinishGroup } from "../services/ConnectDataBase";
import { SCREEN_IDS } from "../components/FullComponent.js";
import { typeConnect } from "../constants/Constants";
import { translateText } from "../translations/translationService";
import { useSelector } from "react-redux";
import { BRAND_COLORS, BACKGROUND_COLORS, TEXT_COLORS, BORDER_COLORS } from "../style/colors.js";
import { COMPLETED_FOUNDRIES_COLORS } from "../style/colors.js";
const CompletedFoundries = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [listPO, setListPO] = useState([]);
  const [refSearch, setRefSearch] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  // Hook de paginación
  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePagination(0, 20);
  const lang = useSelector((state) => state.lang.value);
  const getGroupListFoundry = useCallback(async () => {
    setIsLoading(true);
    try {
      const options = await getListFullFinishGroup(
        SCREEN_IDS.ADMIN_COMPLETED_FOUNDRY,
        typeConnect[0]
      );

      const poArray = Object.entries(options).map(([po, mo]) => ({
        key: po,
        po,
        mo,
      }));

      const groupedData = poArray.reduce((groups, item) => {
        const agrupacion = item.mo.agrupacion.trim().toLowerCase();
        if (!groups[agrupacion]) {
          groups[agrupacion] = [];
        }
        groups[agrupacion].push(item);
        return groups;
      }, {});

      let groupedArray = Object.entries(groupedData).map(
        ([agrupacion, items]) => ({
          key: agrupacion,
          agrupacion,
          items,
        })
      );

      groupedArray = groupedArray.sort((a, b) => {
        const fechaA = new Date(a.items[0].mo.fecha_agrupacion.date);
        const fechaB = new Date(b.items[0].mo.fecha_agrupacion.date);
        return fechaB - fechaA;
      });

      setListPO(groupedArray);
      setSearchResult(groupedArray);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    getGroupListFoundry();
  }, [getGroupListFoundry]);

  const handleSearch = (text) => {
    setRefSearch(text);

    const filteredResults = listPO.filter((item) => {
      const lowerCaseText = text.toLowerCase();

      return item.items.some((dataItem) => {
        return (
          (typeof dataItem.mo.agrupacion === "string" &&
            dataItem.mo.agrupacion.toLowerCase().includes(lowerCaseText)) ||
          (typeof dataItem.mo.aleacion === "string" &&
            dataItem.mo.aleacion.toLowerCase().includes(lowerCaseText)) ||
          (typeof dataItem.mo.po === "string" &&
            dataItem.mo.po.toLowerCase().includes(lowerCaseText)) ||
          (typeof dataItem.mo.mo === "string" &&
            dataItem.mo.mo.toLowerCase().includes(lowerCaseText)) ||
          (typeof dataItem.mo.tipo === "string" &&
            dataItem.mo.tipo.toLowerCase().includes(lowerCaseText)) ||
          (typeof dataItem.mo.peso === "string" &&
            dataItem.mo.peso.toLowerCase().includes(lowerCaseText)) ||
          (typeof dataItem.mo.lote === "string" &&
            dataItem.mo.lote.toLowerCase().includes(lowerCaseText)) ||
          (typeof dataItem.mo.fecha_agrupacion?.date === "string" &&
            dataItem.mo.fecha_agrupacion.date
              .toLowerCase()
              .includes(lowerCaseText))
        );
      });
    });

    setSearchResult(filteredResults);
  };


  function Row(props) {
    const { group } = props;
    const [open, setOpen] = useState(false);

    return (
      <React.Fragment>
        <TableRow
          onClick={() => setOpen(!open)}
          sx={{
            backgroundColor: BRAND_COLORS.PRIMARY,
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "#174045 !important",
            },
            borderBottom: `1px solid ${COMPLETED_FOUNDRIES_COLORS.BORDER_LIGHT || "#e5e7eb"}`,
          }}>
          <TableCell
            colSpan={9}
            sx={{
              py: 1,
              px: 1.5,
            }}>
            <Typography
              sx={{
                color: "white",
                textAlign: "center",
                fontSize: "0.85rem",
                fontWeight: 400,
              }}>
              {group.agrupacion}
            </Typography>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell
            sx={{
              paddingBottom: 0,
              paddingTop: 0,
              borderBottom: `1px solid ${COMPLETED_FOUNDRIES_COLORS.BORDER_LIGHT || "#e5e7eb"}`,
            }}
            colSpan={9}>
            <Collapse in={open} timeout='auto' unmountOnExit>
              <Box margin={1}>
                <Table size='small'>
                  <TableHead>
                    <TableRow>
                      {[
                        translateText("#", lang),
                        translateText("Agrupación", lang),
                        translateText("Aleación", lang),
                        translateText("PO", lang),
                        translateText("MO", lang),
                        translateText("Tipo", lang),
                        translateText("Peso", lang),
                        translateText("Lote", lang),
                        translateText("Fecha", lang),
                      ].map((header, i) => (
                        <TableCell
                          key={i}
                          sx={{
                            fontWeight: 600,
                            backgroundColor: COMPLETED_FOUNDRIES_COLORS.BACKGROUND_ROW_ALTERNATE || "#F9FAFB",
                            borderBottom: `1px solid ${COMPLETED_FOUNDRIES_COLORS.BORDER_TABLE || "#e5e7eb"}`,
                            fontSize: "0.75rem",
                            color: "black",
                            py: 0.75,
                            px: 1.5,
                          }}>
                          {header}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {group.items.map((dataItem, index) => (
                      <TableRow
                        key={`${dataItem.mo.po}-${index}`}
                        sx={{
                          "&:hover": {
                            backgroundColor: COMPLETED_FOUNDRIES_COLORS.BACKGROUND_ROW_ALTERNATE || "#F9FAFB",
                          },
                          borderBottom: `1px solid ${COMPLETED_FOUNDRIES_COLORS.BORDER_LIGHT || "#e5e7eb"}`,
                        }}>
                        <TableCell
                          sx={{
                            fontSize: "0.8rem",
                            py: 0.75,
                            px: 1.5,
                            color: COMPLETED_FOUNDRIES_COLORS.TEXT_PRIMARY || "#374151",
                          }}>
                          {index + 1}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: "0.8rem",
                            py: 0.75,
                            px: 1.5,
                            color: COMPLETED_FOUNDRIES_COLORS.TEXT_PRIMARY || "#374151",
                          }}>
                          {dataItem.mo.agrupacion}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: "0.8rem",
                            py: 0.75,
                            px: 1.5,
                            color: COMPLETED_FOUNDRIES_COLORS.TEXT_PRIMARY || "#374151",
                          }}>
                          {dataItem.mo.aleacion}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: "0.8rem",
                            py: 0.75,
                            px: 1.5,
                            color: COMPLETED_FOUNDRIES_COLORS.TEXT_PRIMARY || "#374151",
                          }}>
                          {dataItem.mo.po}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: "0.8rem",
                            py: 0.75,
                            px: 1.5,
                            color: COMPLETED_FOUNDRIES_COLORS.TEXT_PRIMARY || "#374151",
                          }}>
                          {dataItem.mo.mo}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: "0.8rem",
                            py: 0.75,
                            px: 1.5,
                            color: COMPLETED_FOUNDRIES_COLORS.TEXT_PRIMARY || "#374151",
                          }}>
                          {dataItem.mo.tipo}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: "0.8rem",
                            py: 0.75,
                            px: 1.5,
                            color: COMPLETED_FOUNDRIES_COLORS.TEXT_PRIMARY || "#374151",
                          }}>
                          {dataItem.mo.peso}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: "0.8rem",
                            py: 0.75,
                            px: 1.5,
                            color: COMPLETED_FOUNDRIES_COLORS.TEXT_PRIMARY || "#374151",
                          }}>
                          {dataItem.mo.lote}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: "0.8rem",
                            py: 0.75,
                            px: 1.5,
                            color: COMPLETED_FOUNDRIES_COLORS.TEXT_PRIMARY || "#374151",
                          }}>
                          {dataItem.mo.fecha_agrupacion?.date
                            ? new Date(dataItem.mo.fecha_agrupacion.date)
                                .toISOString()
                                .split("T")[0]
                            : ""}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <Box sx={{ padding: 1.5 }}>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 1.5,
          padding: 1.5,
          backgroundColor: "white",
          borderRadius: 2,
          boxShadow:
            "0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)",
          border: `1px solid ${COMPLETED_FOUNDRIES_COLORS.BORDER_LIGHT || "#e5e7eb"}`,
          marginBottom: 1.5,
        }}>
        <Box sx={{ flex: 1, minWidth: "280px", position: "relative" }}>
          <InputBase
            value={refSearch}
            onChange={(e) => handleSearch(e.target.value)}
            placeholder={translateText("Buscar", lang)}
            sx={{
              width: "100%",
              backgroundColor: COMPLETED_FOUNDRIES_COLORS.BACKGROUND_CARD || "#F9FAFB",
              color: COMPLETED_FOUNDRIES_COLORS.TEXT_PRIMARY || "#374151",
              fontSize: "0.85rem",
              fontWeight: 500,
              padding: "8px 12px 8px 40px",
              borderRadius: 2,
              border: `1.5px solid ${COMPLETED_FOUNDRIES_COLORS.BORDER_CARD || "#e5e7eb"}`,
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: COMPLETED_FOUNDRIES_COLORS.BACKGROUND_INPUT || "#F3F4F6",
                borderColor: COMPLETED_FOUNDRIES_COLORS.BORDER_BRAND || "#174045",
                boxShadow: "0 2px 4px rgba(70, 93, 100, 0.1)",
              },
              "&.Mui-focused": {
                backgroundColor: "white",
                borderColor: COMPLETED_FOUNDRIES_COLORS.BORDER_BRAND || "#174045",
                boxShadow:
                  "0 0 0 2px rgba(70, 93, 100, 0.1), 0 2px 4px rgba(70, 93, 100, 0.1)",
              },
              "& input": {
                padding: 0,
              },
              "& input::placeholder": {
                color: COMPLETED_FOUNDRIES_COLORS.TEXT_MUTED || "#9CA3AF",
                opacity: 1,
              },
            }}
          />

          <Box
            sx={{
              position: "absolute",
              left: 16,
              top: "50%",
              transform: "translateY(-50%)",
              color: COMPLETED_FOUNDRIES_COLORS.TEXT_MUTED || "#9CA3AF",
              pointerEvents: "none",
            }}>
            <SearchIcon sx={{ fontSize: 18 }} />
          </Box>
        </Box>

        <Button
          onClick={() => handleSearch(refSearch)}
          variant='contained'
          size="small"
          startIcon={<SearchIcon />}
          sx={{
            backgroundColor: COMPLETED_FOUNDRIES_COLORS.BACKGROUND_BUTTON_PRIMARY || "#174045",
            color: "white",
            borderRadius: 2,
            fontSize: "0.8rem",
            fontWeight: 600,
            padding: "6px 16px",
            textTransform: "none",
            boxShadow: "none",
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: COMPLETED_FOUNDRIES_COLORS.BACKGROUND_BUTTON_SECONDARY || "#1e4d52",
              transform: "translateY(-1px)",
              boxShadow: "0 4px 12px rgba(70, 93, 100, 0.2)",
            },
          }}>
          {translateText("Buscar", lang)}
        </Button>

        <Box
          sx={{
            display: { xs: "none", lg: "block" },
            width: "1px",
            height: 32,
            backgroundColor: COMPLETED_FOUNDRIES_COLORS.BORDER_CARD || "#e5e7eb",
          }}
        />

        <Typography variant='h6' sx={{ flex: 1, textAlign: "center", fontSize: "1rem", fontWeight: 600 }}>
          {translateText("Tabla de Agrupaciones finalizadas", lang)}
        </Typography>

        <IconButton
          onClick={() => {
            setRefSearch("");
            handleSearch("");
            getGroupListFoundry();
          }}
          sx={{
            padding: 1,
            color: COMPLETED_FOUNDRIES_COLORS.TEXT_BRAND || "#174045",
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: "rgba(70, 93, 100, 0.08)",
              transform: "scale(1.1)",
            },
          }}>
          <RestartAltIcon />
        </IconButton>
      </Box>

      {isLoading ? (
        <Paper
          sx={{
            borderRadius: 2,
            overflow: "hidden",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            border: `1px solid ${COMPLETED_FOUNDRIES_COLORS.BORDER_LIGHT || "#e5e7eb"}`,
          }}>
          <Box sx={{ p: 2 }}>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ py: 1, px: 1.5 }}>
                      <Skeleton variant="text" width="100%" height={24} />
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {[...Array(5)].map((_, i) => (
                    <TableRow key={i}>
                      <TableCell sx={{ py: 0.75, px: 1.5 }}>
                        <Skeleton variant="text" width="100%" height={20} />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Paper>
      ) : (
        <React.Fragment>
          <Paper
            sx={{
              borderRadius: 2,
              overflow: "hidden",
              boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
              border: `1px solid ${COMPLETED_FOUNDRIES_COLORS.BORDER_LIGHT || "#e5e7eb"}`,
            }}>
            <TableContainer sx={{ maxHeight: "calc(78vh - 60px)" }}>
              <Table stickyHeader size="small" sx={{ width: "100%" }}>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        fontWeight: 600,
                        backgroundColor: COMPLETED_FOUNDRIES_COLORS.BACKGROUND_TABLE_HEADER || "#F9FAFB",
                        borderBottom: `1px solid ${COMPLETED_FOUNDRIES_COLORS.BORDER_TABLE || "#e5e7eb"}`,
                        fontSize: "0.75rem",
                        color: "black",
                        py: 1,
                        px: 1.5,
                      }}>
                      {translateText("Agrupación", lang)}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {searchResult
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((group) => (
                      <Row key={group.key} group={group} />
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Divider />
            <Box sx={{ backgroundColor: COMPLETED_FOUNDRIES_COLORS.BACKGROUND_ROW_ALTERNATE || "#F9FAFB" }}>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                count={searchResult.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  backgroundColor: COMPLETED_FOUNDRIES_COLORS.BACKGROUND_ROW_ALTERNATE || "#F9FAFB",
                  "& .MuiTablePagination-toolbar": {
                    fontSize: "0.75rem",
                    color: COMPLETED_FOUNDRIES_COLORS.TEXT_SECONDARY || "#6B7280",
                    minHeight: "52px",
                  },
                  "& .MuiTablePagination-select": {
                    fontSize: "0.75rem",
                  },
                  "& .MuiTablePagination-displayedRows": {
                    fontSize: "0.75rem",
                  },
                }}
              />
            </Box>
          </Paper>
        </React.Fragment>
      )}
    </Box>
  );
};

export default CompletedFoundries;
